import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

export const SurveyCompletedMessage = () => {
  const {t} = useTranslation();

  return (
    <Grid container mt={5} flexDirection={'column'} alignItems={'center'} textAlign={{xs: 'center', sm: 'left'}}>
      <Grid item>
        <Typography variant='h2'>{t('talents.surveyCompleted.firstLine')}</Typography>
      </Grid>
      <Grid item>
        <Typography variant='h3'>{t('talents.surveyCompleted.secondLine')}</Typography>
      </Grid>
    </Grid>
  );
};
